var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZocoAyuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #b3c300;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #b3c300;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .25px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200,390.42c-105,0-190.42-85.42-190.42-190.42S95.01,9.58,200,9.58s190.41,85.42,190.41,190.41-85.42,190.42-190.41,190.42ZM200,33.17c-91.99,0-166.83,74.84-166.83,166.83s74.84,166.83,166.83,166.83,166.83-74.84,166.83-166.83S291.99,33.17,200,33.17Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.36,231.29v-121.05h45.05c-.01,40.31.71,80.76,0,121.05H31.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.75,231.29v-118.85c13.6.31,27.28,0,40.89,0v118.85c-13.49.69-27.36.01-40.89,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.86,154.44c11.56-9.34,43.52-30.49,59.24-31.55,9.75-.76,20.09-.03,29.91-.03l62.59.03v108.39c-12.33,18.78-31.27-12.12-42.37-23.84-17.07-17.29-32.77-30.11-45.17-51.23-27.06,12.85-42.14,29.01-64.2-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.06,235.35v-111.06l36.01.02c7.13.04,14.31.57,21.42-.02-16.77,9.79-33.83,17.53-24.06,39.65,13.12,29.69,46.33,37.12,74.57,24.12,5.4,6.08,12.11,11.55,17.93,17.3l36.88,37.1c5.71,5.74,13.03,11.64,17.64,18.26,5.04,7.23.22,18.27-8.87,18.15-14.77-.2-33.62-41.1-48.66-41.25-9.05-.09-14.51,9.8-9.78,17.29,3.66,5.79,16.2,17.64,21.69,23.08,3.7,4.59,29.09,29.36,4.21,30.78-16.89.97-32.04-40.29-49.02-38.7-5.13.48-9.93,6.92-9.59,11.9.88,13.18,31.43,28.7,31.87,42.28.28,8.71-10.78,13.34-17.41,8.14-9.19-7.18-17.01-17.28-25.27-25.58-23.4-23.53-46.6-47.48-69.55-71.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZocoAyuda);
export default __webpack_public_path__ + "static/media/Zoco Ayuda.ac24606e6c18abdde03867e09a22036c.svg";
export { ForwardRef as ReactComponent };